import React, { Component } from "react";
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBCollapse,
  MDBContainer,
  MDBNavbarToggler,
  MDBIcon,
  MDBCol,
  MDBRow,
} from "mdbreact";
import Cookies from "js-cookie";

import { withRouter } from "react-router-dom";
import "./css/Header.css";
import { Text } from "../context/Language";
import HeaderProducts from "../components/HeaderAfterLogin/HeaderProducts";
import { HeaderMenuSeller } from "../components/HeaderAfterLogin/HeaderMenuSeller";
import { HeaderMenuUser } from "../components/HeaderAfterLogin/HeaderMenuUser";
// import styles from "./css/Header.module.css";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseID: "",
    };
    this.headerHeight = React.createRef();
  }

  componentDidMount() {
    let headerHeight = this.headerHeight.current.offsetHeight;
    this.props.checkHeaderHeight(headerHeight);
  }

  toggleCollapse = (collapseID) => () =>
    this.setState((prevState) => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : "",
    }));

  render() {
    const logoStyle = {
      minHeight: "2.5rem",
      minWidth: "2.5rem",
      maxHeight: "10rem",
      maxWidth: "10rem",
    };

    const logoContainerStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };
    // console.log(this.props)
    return (
      <MDBNavbar
        color="white"
        light
        expand="lg"
        fixed="top"
        scrolling
        style={{ background: "white", padding: "0" }}
      >
        <span style={{ width: "100%" }} ref={this.headerHeight}>
          <MDBContainer>
            <MDBNavLink className="black-text" to="/">
              <MDBRow>
                <MDBCol style={logoContainerStyle}>
                  <img
                    id="logoHeader"
                    src={this.props.subDomainData.logo}
                    style={logoStyle}
                    className="rounded float-right"
                    alt="aligment"
                  />
                </MDBCol>
                <MDBCol
                  style={{
                    fontFamily: "Alegreya",
                    fontWeight: "500",
                    fontSize: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      margin: "0",
                    }}
                  >
                    {this.props.subDomainData.name_web}
                  </div>
                </MDBCol>
              </MDBRow>
            </MDBNavLink>
            <MDBNavbarToggler onClick={this.toggleCollapse("navbarCollapse")} />
            <MDBCollapse
              id="navbarCollapse"
              isOpen={this.state.collapseID}
              navbar
            >
              <MDBNavbarNav right>
                <MDBNavItem>
                  <HeaderProducts />
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink className="black-text" to="/about">
                    <Text pid="t1_header" tid="aboutBtn" />
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink className="black-text" to="#!">
                    <Text pid="t1_header" tid="faqBtn" />
                  </MDBNavLink>
                </MDBNavItem>
                {this.props.isSeller ? (
                  " "
                ) : (
                  <div className="icon-cart">
                    <MDBNavItem>
                      <MDBNavLink
                        className="black-text align-self-center col-example text-left"
                        to="/cart"
                      >
                        <MDBIcon icon="shopping-cart" />
                        <Text pid="t1_header" tid="cartBtn" />
                      </MDBNavLink>
                    </MDBNavItem>
                  </div>
                )}
                {Cookies.get("access_token") ? (
                  <>
                    <HeaderMenuSeller />
                    <HeaderMenuUser logged={true} logout={this.props.logout} />
                  </>
                ) : (
                  <HeaderMenuUser logged={false} />
                )}
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBContainer>
        </span>
      </MDBNavbar>
    );
  }
}

export default withRouter(Header);
